// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--kra1_","stretch":"da51a739f7--stretch--xdInY"};